export const getDevice = () => {
  // Check if the device is mobile or desktop
  const userAgent = navigator.userAgent.toLowerCase();

  const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(
    userAgent
  );
  const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(
    userAgent
  );
  const isNativeApp =
    typeof window !== "undefined" && "ReactNativeWebView" in window;

  const device = isTablet || isMobile || isNativeApp ? "mobile" : "desktop";
  return device;
};

export const isTouchDevice = (): boolean =>
  "ontouchstart" in window || navigator.maxTouchPoints > 0;

const hasForceIpadParam = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  return new URLSearchParams(window.location.search).get("force") === "ipad";
};

const isEvoIframe = (): boolean =>
  typeof window !== "undefined" && window.location !== window.parent.location;

/** Standalone iPad / native WebView — not the Evo workspace iframe. */
export const isStandaloneTabletLayout = (): boolean => {
  if (hasForceIpadParam()) {
    return true;
  }
  // The native webpack embed is only shipped inside the tablet app. iPadOS
  // WKWebView often reports a Macintosh UA and ReactNativeWebView is not
  // reliably injected, so getDevice() would keep the Evo card chrome.
  if (typeof __REACT_NATIVE_BUILD__ !== "undefined" && __REACT_NATIVE_BUILD__) {
    return true;
  }
  if (isEvoIframe()) {
    return false;
  }
  return getDevice() === "mobile";
};

/** Hover tooltips open on tap and then stay on screen. Tablets do not get them. */
export const supportsHoverTooltip = (): boolean => {
  if (typeof navigator === "undefined") {
    return true;
  }
  const ua = navigator.userAgent;
  if (/(ipad|tablet|playbook|silk)|(android(?!.*mobile))/i.test(ua)) {
    return false;
  }
  // iPadOS reports a Macintosh user agent. A mouse still has one touch point.
  if (navigator.maxTouchPoints > 1 && /macintosh/i.test(ua)) {
    return false;
  }
  return !isStandaloneTabletLayout();
};
